var bt = {
    apiBaseURL: trackers.activeConfiguration.leadsApi,
    isCPA: true,
    staging: (trackers.env == "staging"),
    affnetworks: []
};


var $j3 = $; // capture jquery 


bt.validateEmail = function (email, callback) {
    var emailRegex = /^(?!.{255,})(([a-z]{2}@)|((?!.*[+.-]+@)(?!.*[+-._]{2,})(?![^a-z]+@)[a-z0-9][+a-z0-9._-]+))@(([a-z0-9]([a-z0-9-_]+\.)+|[a-z]\.)[a-z]{2,})$/i;

    var url = "https://www.xverify.com/services/emails/verify/?type=json&apikey=1007729-ADDD229C&domain=biotrust.com&email=" + encodeURIComponent(email);

    // First test regex
    if (!emailRegex.test(email) || /\b(enter|youremail)\b/i.test(email)) {
        if (callback) { callback(false); }
        return false;
    }

    // If we don't have a call back just return true as we are only validating basic email
    if (!callback) { return true; }

    $.ajax({ url: url, timeout: 2000, dataType: "jsonp" })
        .done(function (data) {
            try {
                if (data.email.responsecode == 1 || data.email.responsecode == 3) {
                    callback(true);
                }
                else {
                    callback(false);
                }
            }
            catch (err) {
                callback(true);
            }
        })
        .fail(function (err) {
            callback(true);
        });
}

var urlparams = location.search.split(/[?&]/).map(x => x.split("=")).filter(x => x.length > 0 && x[0] != "").reduce((x, y) => { x[y[0].toLowerCase()] = decodeURIComponent(y[1]); return x }, {});

bt.isRegisteredLead = function (email, dealName) {
    return new Promise((resolve, reject) => {
        var ck = Cookies.getJSON('choffer');
        if (ck && ck[dealName] == email) {
            resolve(true);
            return;
        }

        $.get(bt.apiBaseURL + "/deal/conversion", {
            "Email": email,
            "DealName": dealName
        })
            .done(data => {
                resolve(data.hasConverted);
            })
            .fail(xhr => {
                resolve(false);
            });
    });
}

bt.sendLead = function (email, params) {
    return new Promise((resolve, reject) => {
        var search = location.search.split(/[?&]/);
        var t = search.map(x => x.split("=")).filter(x => x.length > 0 && x[0] != "" && x[0] != 'email').map(x => ({ "name": x[0], "value": decodeURIComponent(x[1]) }));
        var obj = {
            "optInName": params.optInName || "",
            "email": email,
            "contactTags": params.contactTags || [],
            "params": t,
            "isCPA": bt.isCPA
        };

        console.log("sending: " + JSON.stringify(obj));

        $.ajax({
            url: bt.apiBaseURL + "/lead/opt-in",
            crossDomain: false,
            method: "POST",
            contentType: "application/json",
            processData: false,
            data: JSON.stringify(obj)
        })
            .done(data => {
                try {
                    resolve(data.transactionId);
                }
                catch (e) {
                    resolve(false);
                }
            })
            .fail(xhr => {
                console.log("failed with: " + xhr.responseText);
                resolve(false);
            });
    });
}

bt.submitLander = function ($form) {
    var action = $form.attr("action");
    var $variant = $form.find("[name=variant]");
    var $email = $form.find("[name=email]");
    var $submit = $form.find("input:submit");
    var contactTags = $form.find("[name=contactTags]").val().split(",");
    var optInName = $form.find("[name=optInName]").val();
    var dealName = $form.find("[name=dealName]").val();
    var email = $email.val();
    var variant = $variant.val();

    if ($variant.length > 0 && variant == "") {
        alert("Please choose your flavor.");
        $variant.focus();
        return false;
    }

    bt.optin.disable($("input"), $("select"));

    email = email.replace(/\s+/g, "");
    $email.val(email);

    bt.validateEmail(email, result => {
        if (result) {

            let sendLead = bt.sendLead(email, { optInName: optInName, contactTags: contactTags });
            let validLead = bt.isRegisteredLead(email, dealName).then(status => {
                if (status == true) {
                      trackers.event('lead', { category: 'Opt-in Sales Page', label: optInName, name: 'Duplicate Email Error' });
                    $j3("#usedError").modal({ backdrop: "static", keyboard: false });
                }
                return status;
            });
            Promise.all([sendLead, validLead]).then(results => {
                if (results[1] === false) {
                  trackers.event('lead', { category: 'Opt-in Sales Page', name: 'Opt-in', label: optInName, currency: 'USD', value: '0', fb_lead: true });
                  
                    var ck = Cookies.getJSON('choffer') || {};
                    var gid = encodeURIComponent(CryptoJS.AES.encrypt(email, "EaHeydWlBFzwbkbb").toString());

                    ck.pending = dealName;
                    Cookies.set('choffer', ck, { expires: new Date(new Date().getTime() + 10 * 60 * 1000) }); // expire in 10 mins
                    Cookies.set('hasoffer', { 'offerId': urlparams.utm_offer, 'transactionId': results[0], 'email': email }, { expires: 1 });
                    var v = variant ? variant + '&' : '?';
                    location.href = `${action}${v}gid=${gid}`;
                }
            });
        }
        else {
            trackers.event('lead', { category: 'Opt-in Sales Page', name: 'Opt-in Email Error', label: optInName });

            bt.optin.enable($("input"), $("select"));


            alert("The email address you entered is not valid. Please enter a valid email address.");
            $email.focus().val("");
        }
    });



    return false;
}


bt.optin = {
    "disable": function (...elements) {
        elements.forEach(x => x.css("opacity", .75).attr("disabled", ""));
    },
    "enable": function (...elements) {
        elements.forEach(x => x.css("opacity", "").attr("disabled", null));
    }
};


$(function () {
    $("#email").change(function () {
        var email = $(this).val();
        $(this).val(email.replace(/\s+/g, ""));
    });

    $("#email").closest("form").submit(function (e) {
        var $email = $(this).find("#email");
        var $submit = $(this).find("#submit");
        var $form = $(this);
        var offer = urlparams.utm_offer;
        var email = $email.val().replace(/\s+/g, "");
        var optInName = $form.find("#optInName").val();
        var url = $form.attr("action");

        function disable() {
            bt.optin.disable($email, $submit);
        }

        function enable() {
            bt.optin.enable($email, $submit);
        }

        disable();

        if (offer) {
            url += (/\?/.test(url) ? "&" : "?") + "offer=" + offer;
        }

        bt.validateEmail(email, function (success) {
            if (!success) {
                enable();

              trackers.event('lead', { category: 'Opt-in', label: optInName, name: 'Opt-in Email Error' });
                alert("The email address you entered is not valid. Please enter a valid email address.");
                $email.val("").focus();
            }
            else {
              trackers.event('lead', { category: 'Opt-in', name: 'Opt-in', label: optInName });

                bt.sendLead(email, {
                    optInName: optInName,
                    contactTags: ($form.find("#contactTags").val() || "").split(",")
                }).then(code => {
                    location.href = url;
                });
            }
        });

        e.preventDefault();
        e.stopImmediatePropagation();
    });
});

$(function () {
    if (bt.isCPA) {                       
        let networks = Cookies.getJSON('affNetworkOffers') || {};

        bt.affnetworks.forEach(x => x(networks));
        
        Cookies.set('affNetworkOffers', networks, { expires: 1 });
    }
});





$(function () {
    function dce(msg) {
        function hexToBase64(str) {
            return btoa(String.fromCharCode.apply(null,
                str.replace(/\r|\n/g, "").replace(/([\da-fA-F]{2}) ?/g, "0x$1 ").replace(/ +$/, "").split(" "))
            );
        }

        let salt = CryptoJS.enc.Hex.parse(msg.substr(0, 64));
        let iv = CryptoJS.enc.Hex.parse(msg.substr(64, 32));

        let encrypted = hexToBase64(msg.substring(96));

        let key = CryptoJS.PBKDF2("EaHeydWlBFzwbkbb", salt, {
            keySize: 8,
            iterations: 1000
        });

        return CryptoJS.AES.decrypt(encrypted, key, {
            iv: iv,
            padding: CryptoJS.pad.Pkcs7,
            mode: CryptoJS.mode.CBC
        }).toString(CryptoJS.enc.Utf8);
    }

    if (urlparams["email"]) {
            let email = dce(urlparams['email']);
            if (email) {
                $("[name=email]").val(email.replace(/\s+/g, ''));
            }
    }
});



bt.affnetworks = [
    function cj(o) {
        if (urlparams.cjevent) {
            o.cj = {
                type: "cj", 
                cjevent: urlparams.cjevent,
                order: {
                    container: 31807,
                    action: 412375,
                    cid: 1554036
                },
                subscription: {
                    container: 31806,
                    action: 412376,
                    cid: 1554036
                }
            };
        }
    },
    
    function hasoffer(o) {
        if (urlparams.utm_offer) {
            let funnels = [];
            // Grab any of the funnel identifiers we can find on the page, either by links or submits
            $("a,form,input").each((_, e) => {
                let m = /\/checkout\/(.+?)(\/|$)/i.exec(e.href || e.action);
                if (m && !funnels.includes(m[1])) {
                    funnels.push(m[1]);
                }
            });
            
            // Now push any carthook funnel ids if we have them
            if (typeof carthook_funnel_ids !== "undefined") {
                carthook_funnel_ids = Array.isArray(carthook_funnel_ids) ? carthook_funnel_ids : [carthook_funnel_ids];
                carthook_funnel_ids.filter(x => !funnels.includes[x]).forEach(x => funnels.push(x));
            }

            o[`hasoffer_${funnels.join('_')}`] = {
                type: 'hasoffer',
                offer: urlparams.utm_offer,
                funnels: funnels
            }

            console.log('Has offers detected these funnels', funnels);
        }
    }
];
